import React from 'react';
import cx from 'classnames';

import styles from './OurMissionSection.module.scss';
import img from 'assets/images/about/target.svg';

export default function OurMissionSection() {
  return (
    <div className={styles.ourMissionSection}>
      <div className={styles.circle}></div>
      <div className={styles.container}>
        <div className={styles.row}>
          <div className={styles.listBox}>
            <h2 className="corp-title">OUR MISSION</h2>
            <p>
              myBasePay provides the urgent service technology an external
              workforce requires with the benefits temp workers deserve.
            </p>
            <p>
              We manage the most critical part of the contractor lifecycle and
              support talent professionals through our customer-obsessed service
              practices, all powered by world-class technology.
            </p>
          </div>
          <div className={styles.image}>
            <img src={img} alt="target" />
          </div>
        </div>
      </div>
      <div className={cx(styles.circle, styles.circleSecond)}></div>
    </div>
  );
}
